var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import "./MutualFundsStyleSheet/MFTransfer.scss";
import TopCurvedGenericTabs from "@frameworks/shared-library/components/TopCurvedGenericTabs/TopCurvedGenericTabs";
import AllClientsTab from "./ClientTabs/AllClientsTab";
import SyncedClientsTab from "./ClientTabs/SyncedClientsTab";
import MoreClientsTab from "./ClientTabs/MoreClientsTab";
import { getArnTabDetails } from "@frameworks/arn-transfer/api/ArnTab";
import { LogoLoader } from "@frameworks/shared-library/components/Loader";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
export var ETransferInClientTabs;
(function (ETransferInClientTabs) {
    ETransferInClientTabs["ALL_CLIENTS"] = "1";
    ETransferInClientTabs["SYNCED_CLIENTS"] = "2";
    ETransferInClientTabs["MORE_CLIENTS"] = "3";
})(ETransferInClientTabs || (ETransferInClientTabs = {}));
var clientTabsArray = [
    {
        title: React.createElement("span", { className: "DMSanN_16_400" }, "All Clients"),
        eventKey: ETransferInClientTabs.ALL_CLIENTS,
        tabContent: React.createElement(AllClientsTab, null),
    },
    {
        title: React.createElement("span", { className: "DMSanN_16_400" }, "Synced Clients"),
        eventKey: ETransferInClientTabs.SYNCED_CLIENTS,
        tabContent: React.createElement(SyncedClientsTab, null),
    },
    {
        title: React.createElement("span", { className: "DMSanN_16_400" }, "More Clients"),
        eventKey: ETransferInClientTabs.MORE_CLIENTS,
        tabContent: React.createElement(MoreClientsTab, null),
    },
];
var MFTransfer = function () {
    var _a;
    var zoom = useCalculateZoom();
    var _b = __read(useState(false), 2), isAnyClientSynced = _b[0], setIsAnyClientSynced = _b[1];
    var _c = __read(useState(), 2), transferInClientTab = _c[0], setTransferInClientTab = _c[1];
    var _d = __read(useState(false), 2), isLoader = _d[0], setIsLoader = _d[1];
    var _e = __read(useState(false), 2), isError = _e[0], setIsError = _e[1];
    var getArnTabDetailsData = function () {
        setIsLoader(true);
        getArnTabDetails()
            .then(function (resp) {
            var _a;
            if ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) {
                var filteredTabs = clientTabsArray.filter(function (tab) { var _a; return (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.some(function (item) { return (item === null || item === void 0 ? void 0 : item.tabId) === Number(tab === null || tab === void 0 ? void 0 : tab.eventKey); }); });
                if ((filteredTabs === null || filteredTabs === void 0 ? void 0 : filteredTabs.length) > 1) {
                    setIsAnyClientSynced(true);
                }
                setTransferInClientTab(filteredTabs);
            }
            setIsError(false);
            setIsLoader(false);
        })
            .catch(function (err) {
            setIsError(true);
            setIsAnyClientSynced(false);
            setIsLoader(false);
        });
    };
    useEffect(function () {
        getArnTabDetailsData();
    }, []);
    return (React.createElement(React.Fragment, null,
        isLoader && React.createElement(LogoLoader, null),
        isError ? (React.createElement(Errormsg, { image: noResultsFound, parentClassName: "bg_white" })) : (React.createElement(TopCurvedGenericTabs, { topLevelTabs: transferInClientTab, horizontalScroll: true, defaultActiveKey: transferInClientTab ? (_a = transferInClientTab === null || transferInClientTab === void 0 ? void 0 : transferInClientTab[0]) === null || _a === void 0 ? void 0 : _a.eventKey : "", parentClassName: "arn-transfer-tabs", parentStyle: { zoom: zoom } }))));
};
export default MFTransfer;
